import { render, staticRenderFns } from "./CadastrarRecepcionista.vue?vue&type=template&id=bce3fe58&scoped=true"
import script from "./CadastrarRecepcionista.vue?vue&type=script&lang=js"
export * from "./CadastrarRecepcionista.vue?vue&type=script&lang=js"
import style0 from "./CadastrarRecepcionista.vue?vue&type=style&index=0&id=bce3fe58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce3fe58",
  null
  
)

export default component.exports